import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import logo from "../Assets/logo-action.webp"; // Importando a logo da Act!on

function Footer() {
  let date = new Date();
  let year = date.getFullYear();

  return (
    <Container fluid className="footer-final">
      <Row>
        <Col className="footer-content">
          <img src={logo} alt="Act!on Logo" className="footer-logo" />
          <p>Copyright © {year} Act!on. Todos os Direitos Reservados.</p>
        </Col>
      </Row>
    </Container>
  );
}

export default Footer;